module.exports = __webpack_public_path__ + "img/apoio-comite.9d033a56.png";